import styled from 'styled-components'
import React from 'react'

// Base Table Structure
const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  overflow: hidden;
`
// rounded table
// border-radius: 8px;

const TableHeader = styled.thead`
  background: var(--primary-100);
`
// rounded table
// tr:first-child th:first-child {
//   border-top-left-radius: 8px;
//   border-bottom-left-radius: 8px;
// }

// tr:first-child th:last-child {
//   border-top-right-radius: 8px;
//   border-bottom-right-radius: 8px;
// }

const TableHeaderRow = styled.tr`
  height: 44px;

  @media (max-width: 968px) {
    display: none;
  }
`

const TableHeaderCell = styled.th<{
  width?: string
  sortable?: boolean
  textAlign?: 'left' | 'center' | 'right'
  spreadsheet?: boolean
}>`
  padding: 12px 16px;
  text-align: ${(props) => props.textAlign ?? 'left'};
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-700);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: var(--primary-100);
  border-bottom: 1px solid var(--primary-200);
  border-top: 1px solid var(--primary-200);
  ${(props) =>
    props.spreadsheet &&
    `
    border-right: 1px solid var(--neutral-300);
    border-left: 1px solid var(--neutral-300);
  `}
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.sortable && `cursor: pointer;`}

  &:first-child {
    border-left: 1px solid var(--primary-200);
  }

  &:last-child {
    border-right: 1px solid var(--primary-200);
  }

  &:hover {
    ${(props) => props.sortable && `background: var(--primary-50);`}
  }

  .sort-content {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: ${(props) => (props.textAlign === 'center' ? 'center' : 'flex-start')};
  }
`

const TableBody = styled.tbody``
// rounded table
// tr:last-child td:first-child {
//   border-bottom-left-radius: 8px;
// }

// tr:last-child td:last-child {
//   border-bottom-right-radius: 8px;
// }

const TableRow = styled.tr<{hover?: boolean; selected?: boolean}>`
  height: 44px;
  background: ${(props) => (props.selected ? 'var(--primary-50)' : 'white')};

  ${(props) =>
    props.hover &&
    `
    &:hover {
      background: var(--neutral-50);
      }
      `}
`
// reounded table
// &:first-child {
//   td {
//     border-top: 1px solid var(--neutral-200);
//     padding-top: 16px;
//   }

//   td:first-child {
//     border-top-left-radius: 8px;
//   }

//   td:last-child {
//     border-top-right-radius: 8px;
//   }
// }

const TableCell = styled.td<{
  width?: string
  textAlign?: 'left' | 'center' | 'right'
  showBorder?: boolean
  spreadsheet?: boolean
}>`
  padding: 12px 16px;
  text-align: ${(props) => props.textAlign ?? 'left'};
  font-size: 14px;
  color: var(--neutral-700);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: white;
  border-bottom: 1px solid var(--neutral-200);
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.showBorder && `border-right: 1px solid var(--neutral-400);`}
  ${(props) =>
    props.spreadsheet &&
    `
    border-right: 1px solid var(--neutral-300);
    border-left: 1px solid var(--neutral-300);
    border-top: 1px solid var(--neutral-300);
    border-bottom: 1px solid var(--neutral-300);
  `}
`

// &:first-child {
//   border-left: 1px solid var(--neutral-300);
// }

// &:last-child {
//   border-right: 1px solid var(--neutral-300);
// }

// Mobile Table Wrapper - Based on working ronos-2.0 implementation
const MobileTableWrapper = styled.div`
  .cell-header {
    display: none;
  }

  @media (max-width: 968px) {
    .thead {
      display: none !important;
    }
    .table-header {
      display: none;
    }

    .table-row {
      display: block !important;
      height: auto !important;
      border: 1px solid #e5e7eb;

      margin-bottom: 12px;
      padding: 16px;
      background: white !important;
    }

    .table-cell {
      display: flex !important;
      justify-content: space-between;
      align-items: flex-start;
      padding: 8px 0;
      border-bottom: 1px solid #f3f4f6;
      height: auto !important;
      min-height: auto !important;
    }

    .table-cell:last-child {
      border-bottom: none;
    }

    .cell-header {
      display: block;
      font-weight: 600;
      color: #6b7280;
      font-size: 12px;
      margin-bottom: 4px;
    }
  }
`

export const EllipsisText = styled('span')`
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
`

// Table Container with styling - supports custom style and className props
interface TableContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

const TableContainer = styled.div<TableContainerProps>`
  background: white;
  border-radius: 16px;
  border: 1px solid var(--primary-100);
  padding: 20px;
  box-shadow: var(--shadow-strong);
`

export {
  Table,
  TableHeader,
  TableHeaderRow,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  MobileTableWrapper,
  TableContainer,
}

export type {TableContainerProps}
